let n = !1;
function o(r) {
  n = r;
}
function u() {
  return n;
}
class l {
  constructor() {
    this.listeners = {};
  }
  /**
   * Registers an event listener for the specified event.
   *
   * @param event - The name of the event to listen for.
   * @param callback - The function to call when the event is emitted.
   */
  on(e, i) {
    let t = this.listeners[e];
    t || (t = []), t.push(i), this.listeners[e] = t;
  }
  /**
   * Unregisters an event listener for the specified event.
   *
   * @param event - The name of the event to stop listening for.
   * @param callback - The function to remove from the event listeners.
   */
  off(e, i) {
    let t = this.listeners[e];
    t && (this.listeners[e] = t.filter(
      (s) => s !== i
    ));
  }
  /**
   * Emits the specified event, calling all registered listeners with the provided arguments.
   *
   * @param event - The name of the event to emit.
   * @param args - The arguments to pass to the event listeners.
   */
  emit(e, i) {
    var t;
    n && console.debug(
      `EventEmitter: Emitting event '${e.toString()}' with arguments:`,
      i
    ), (t = this.listeners[e]) == null || t.forEach((s) => s(i));
  }
}
function E() {
  return new l();
}
export {
  l as EventEmitter,
  E as createEventEmitter,
  u as getEventEmitterDebugMode,
  o as setEventEmitterDebugMode
};
